<ion-header>
  <ion-toolbar color="primary">
    <ion-title>Tiendas participantes</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-text-center">
  <ion-list>
    <ion-item *ngFor="let store of contestStores">
      <ion-label>
        <h2>{{store.name}}</h2>
        <h4 *ngIf="store.brandName">{{store.brandName}}</h4>
        <!-- <p>{{store.nit}}</p> -->
        <p>{{store.document_number}}</p>
      </ion-label>

    </ion-item>
  </ion-list>
</ion-content>
